<template lang="pug"> 
  v-row(no-gutters justify="center")
    v-col(cols=12 md=6).px-3.pt-5
      v-form(
        ref='form'
        @submit.prevent
      )
        v-row 
          v-col(cols=12)
            n-select-bank-type(
              v-model='form.bank_type_id'
              :rules='bankRules'
              :label="$t('label.bank')"
              :disabled='status||!editstat||current.bank_type_id'
            )
          v-col(cols=12)
            n-number-field-specific(
              v-model='form.accountNumber'
              :rules='accountNumberRules'
              dense
              outlined
              hideDetails="auto"
              :disabled='status||!editstat||current.accountNumber'
              :label="$t('label.bank-number')"
              :placeholder="$t('placeholder.bank-number')"
            )
          v-col(cols=12)
            v-text-field(
              v-model='form.nameAccount'
              dense
              outlined
              hideDetails="auto"
              :disabled='status||!editstat||current.nameAccount'
              :label="$t('label.bank-account-full-name')"
              :placeholder="$t('placeholder.bank-account-full-name')"
            ) 
          v-col(cols=12)
            v-row.d-flex.justify-center.align-center
              v-col(cols=12)
                v-card(@click="openFile" :disabled='status||!editstat').bank.d-flex.justify-center.align-center.pa-10
                  v-img(v-if="form.qr_url" :src='form.qr_url' width='80%')
                  div(v-if="!form.qr_url")
                    | {{ $t('label.bank-account-qr') }}
          //- v-if="editable"
          v-col(
            v-if="false" 
            cols=12
          )
            n-btn-submit(
              v-if='!editstat' 
              @click='edit'
            ) {{ $t('button.edit') }}
            n-btn-submit(
              v-else
              @click='submit'
            ) {{ $t('button.save') }}
            
</template>
<script> 
import { users as apiMe } from '@/apis'  
import Validation from '@/mixins/Validations'
import jsQR from 'jsqr';

export default { 
  mixins: [Validation],    
    data: () => ({
      form:{
        bank_type_id: null,
        accountNumber: null,
        nameAccount: null,
        bank_qr_image_url: null,
        qr_url: null,
      },
      current: {
        bank_type_id: null,
        accountNumber: null,
        nameAccount: null,
      },
      status:false,
      editstat: false, 
      editable: false,
    }),  
    computed: {
      userProfile () {
        return this.$store.getters['userProfile/GETTERS_ME']
      },
    },
    watch : {
      userProfile () {
        if(this.userProfile){
          this.setInitial() 
        }
      }
    },
    async mounted () {
      this.setInitial()

      if (this.$route.query.tab === "bank") {
        const query = Object.assign({}, this.$route.query);
        
        delete query.tab;
        this.$router.replace({ query });

        this.editstat = true;
      }
    }, 
    methods: { 
      async setInitial () {
        const { bank_type, bank_number, bank_name, bank_qr_image_url} = this.userProfile
        this.form.bank_type_id = bank_type?.id
        this.form.accountNumber = bank_number
        this.form.nameAccount = bank_name 
        this.form.bank_qr_image_url = bank_qr_image_url
        this.form.qr_url = bank_qr_image_url

        // update current data
        this.current.bank_type_id = bank_type?.id
        this.current.accountNumber = bank_number
        this.current.nameAccount = bank_name 

        this.editable = !bank_qr_image_url
      },
      openFile () {
        const input = document.createElement('input');
        
        input.type = 'file';
        input.click();

        input.addEventListener('change', async () => {
          const file = input.files[0];

          if (!file) {
            return;
          }

          const reader = new FileReader();
      
          reader.onload = async (event) => {
            const imageData = event.target.result;
            const qrText = await this.decodeQR(imageData);

            if (qrText != null) {
              this.form.bank_qr_image_url = file
              this.form.qr_url = URL.createObjectURL(file);
            } else {
              this.$alert('', 'รูป PromptPay QR ไม่ถูกต้อง', 'warning')
              this.form.bank_qr_image_url = null
              this.form.qr_url = null
            }
          };
          
          reader.readAsDataURL(file);
        });
      },
      async submit () { 
        this.$ga.event('Submit', 'ChangeBank', 'SettingPage','' )   

        if(this.$refs.form.validate() && this.editable) {      

          let params = new FormData();

          params.append('bank_type_id', this.form.bank_type_id)
          params.append('bank_number', this.form.accountNumber)
          params.append('bank_name', this.form.nameAccount)

          if (this.form.bank_qr_image_url) {
            params.append('bank_qr_image', this.form.bank_qr_image_url)
          }

          const [err, data, message] = await apiMe.updateProfileFormData(params)

          if(err){
            this.$alert('',err,'warning')
            return
          }

          this.$alert('', message, 'success').then(() => {
            this.$router.go();
          });

          this.$store.commit('userProfile/MUTATION_ME', data) 

          this.editstat = !this.editstat
          this.editable = !data.bank_type
        }
      },
      edit (){
        this.editstat = !this.editstat
      },
      decodeQR (imageData) {
        return new Promise((resolve) => {
          const image = new Image();
          
          image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = image.width;
            canvas.height = image.height;
            ctx.drawImage(image, 0, 0);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height);
            
            if (code) {
              resolve(code.data);
            } else {
              resolve(null);
            }
          };
          image.src = imageData;
        });
      }
    }
}
</script>
<style scoped> 
.bank {
  width: 100%;
  aspect-ratio: 5 / 2;
  background-color: #F0E0F0; 
  border-radius: 8px;
  box-shadow: unset !important;
  cursor: pointer;
}

.v-card--disabled > *:not(.v-card__progress) {
  opacity: 0.9 !important;
}
</style>
